<template>
    <v-dialog
    v-model="dialog"                
    width="400"    
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                {{this.dialogData.titulo}}    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                {{this.dialogData.contenido}}
            </v-card-text>                        
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                flat
                @click="noOrder()"
            >
                Visita sin pedido
            </v-btn>
            <v-btn                
                color="primary"
                flat                
                @click="setOrder()"
            >
                Pedido
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'calEventlDialog',
    data () {
      return {             
         
      }
    },
    methods:{                        
        noOrder(){
            //console.log(this.dialogData);
            this.visitaSinPedido(this.dialogData.event.no);
            this.dialog = false;
        },
        setOrder(){
            this.$store.state.custFilter = this.dialogData.event.customer;
            this.$store.state.idEvento = this.dialogData.event.no;        
            this.getCustomers(true);          
            this.dialog = false;
        }
    },
    computed: {     
        dialog:{
            get(){
                return this.$store.state.calEventDialog;
            },
            set(value){
                //this.$store.commit('setCalEventDialog', value)
                this.$store.state.calEventDialog = value;
            }
        }, 
        dialogData: {
            get(){
                return this.$store.state.calEventDialogData;
            }
        }
    } 
}
</script>

